// extracted by mini-css-extract-plugin
export default {"cluster":"PickupAddressMapCluster_cluster__Ew3R6","badge":"PickupAddressMapCluster_badge__3EaVb"};